import { MAVENCERY_STORES_NAMES } from "constants";
import { Texts } from "constants";
import React from "react";
import { useSelector } from "react-redux";

const SignupInfo = ({ onClick }) => {
  const { selectedStore } = useSelector((store) => store.selectedStore);

  return (
    <div className="w-full space-y-3 h-72 py-auto login-text-container">
      <h4 className="text-3xl font-bold">{Texts.createAccountText}</h4>
      <h5 className="text-2xl font-bold">
        {!selectedStore?.isWhiteLabel
          ? Texts.mavencerySignupAndJoinText
          : selectedStore?.isWhiteLabel &&
            selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
          ? Texts.alHalalSignupAndJoinText
          : Texts.nisaLocalSignupAndJoinText}
      </h5>
      <p>
        {!selectedStore?.isWhiteLabel
          ? Texts.mavencerySignupDescriptionText
          : selectedStore?.isWhiteLabel &&
            selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
          ? Texts.alHalalSignupDescriptionText
          : Texts.nisaLocalSignupDescriptionText}
      </p>
      <button
        onClick={onClick}
        className="px-3 py-2 border border-black rounded-md hover:border-gray-600 "
      >
        Signup
      </button>
    </div>
  );
};

export default SignupInfo;
